/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Include_TimestampInputs */

const en_dialog_include_timestamp = /** @type {(inputs: Dialog_Include_TimestampInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Include Timestamp`)
};

const es_dialog_include_timestamp = /** @type {(inputs: Dialog_Include_TimestampInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incluir marca de tiempo`)
};

/**
* | output |
* | --- |
* | "Include Timestamp" |
*
* @param {Dialog_Include_TimestampInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_include_timestamp = /** @type {((inputs?: Dialog_Include_TimestampInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Include_TimestampInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_include_timestamp(inputs)
	return en_dialog_include_timestamp(inputs)
});